import { defineStore } from "pinia";
import { tokenName } from "./tokenName";
import { personalInfoName } from '~/stores/tokenName'
export const userLogin = defineStore('userLogin', {

    state: () => ({
        isLogin: false,
        userLogin: 0
    }),
    actions: {
        changeLogin() {
            this.isLogin = true
            console.log('登录状态改变了', this.isLogin)
        }
    },
    getters: {
        getLogin(): boolean {
            // const useToken = useCookie(tokenName);
            // if(useToken.value === null){
            //     this.isLogin = false
            //     return this.isLogin
            // }
            console.log('获取到的登录状态', this.isLogin)
            return this.isLogin
        },
        getUserRole(): number {
            const personalInfo = useCookie(personalInfoName);
            return personalInfo.value?.role ?? 0; // 默认返回 0
        }
    }

})